/* The whole job above the Schedule's columns (Duncan 2026-10-29, the PM meeting: Johnny's "total project percentage
   completion"; then 10-30: "a header above" the columns, not a line on the schedule, its dates and % "to the left", and no
   "Whole job" label): the job's name, its dates and its % -- its tasks counted by working days (lib/rollup.js). */
import React from 'react';
import { workingDays } from '../lib/rollup';

const fmt = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ''));
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '–';
};

/** `job`: { name, start, finish, pct }. */
export default function JobHeader({ job, workWeek = '5' }) {
  if (!job || !job.start) return null;
  const pct = job.pct == null ? 0 : job.pct;
  const days = workingDays(job.start, job.finish, workWeek);
  const divider = <span aria-hidden style={{ width: 1, alignSelf: 'stretch', background: 'color-mix(in oklch, var(--accent) 35%, transparent)' }} />;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap', padding: '12px 18px', margin: '0 0 10px', borderRadius: 12,
      background: 'color-mix(in oklch, var(--accent) 12%, var(--bg-surface))', border: '1px solid color-mix(in oklch, var(--accent) 32%, transparent)',
    }}>
      <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-1)', letterSpacing: '-0.015em' }}>{job.name || 'This job'}</div>
      {divider}
      <div>
        <div className="mono" style={{ fontSize: 14, color: 'var(--text-1)', fontWeight: 600 }}>{fmt(job.start)} → {fmt(job.finish)}</div>
        <div className="mono" style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>
          {days} {String(workWeek) === '7' ? 'days' : 'working days'}
        </div>
      </div>
      {divider}
      <div title="The job's tasks, counted by working days" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 180, height: 10, borderRadius: 999, background: 'color-mix(in oklch, var(--text-3) 20%, transparent)', overflow: 'hidden' }}>
          <div style={{ width: `${Math.min(pct, 100)}%`, height: '100%', background: pct >= 100 ? 'var(--success)' : 'var(--accent)', borderRadius: 999 }} />
        </div>
        <span className="mono" style={{ fontSize: 20, fontWeight: 800, color: 'var(--text-1)', letterSpacing: '-0.02em' }}>{pct}%</span>
        <span style={{ fontSize: 12.5, color: 'var(--text-3)' }}>done</span>
      </div>
    </div>
  );
}
